import { isSubnavigationItem, SubnavigationItem } from './navigation';

export const getRequestTabFromUrlParams = (
  typeFromUrl: string,
): SubnavigationItem =>
  isSubnavigationItem(typeFromUrl) ? typeFromUrl : SubnavigationItem.All;
